<template>
	<div class="favorites">
		<van-nav-bar :title="title" fixed border>
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
			</template>
		</van-nav-bar>
		<div class="collapse">

			<van-sticky :offset-top="40">
				<van-tabs v-model="f_type">
					<van-tab :title="s.name" v-for="(s, i) in ftypes" :key="i"></van-tab>
				</van-tabs>
			</van-sticky>

			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    			<div class="empty" v-if="items.length==0"><span class="msg">暂无收藏</span></div>
				<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="items.length==0?'':'没有更多收藏了'"
				@load="loadData"
				>
					<van-swipe-cell>
						<van-card
						  :origin-price="item.g_price_origin>0?item.g_price_origin:null"
						  :price="item.g_price"
						  :title="item.g_name"
						  :thumb="item.g_img?(attach_url+item.g_img):''"
						  v-for="(item,index) in items"
						  :key="'k2_'+index"
						  @click="viewInfo(item.url)"
						  v-if="ftypes[f_type]['key']==2"
						>
							<template #tags v-if="item.g_day_limit>0">
								<van-tag plain type="danger">每天限售 {{item.g_day_limit}} {{goodUnitObj[item.g_unit]}}</van-tag>
							</template>
						</van-card>

						<van-card
						  :title="item.s_name"
						  :tag="item.express?'可配送':''"
						  :thumb="attach_url+item.s_img"
						  v-for="(item,index) in items"
						  :key="'k1_'+index"
						  @click="viewInfo(item.url)"
						  v-if="ftypes[f_type]['key']==1"
						>
							<template #desc>
								<div class="van-card__desc van-ellipsis"><van-icon name="location-o" />{{item.s_address}}</div>
							</template>
							<template #num v-if="item.distance>-1">
								{{item.distance|distance_format}}
							</template>
							<template #price>
								<van-icon name="phone-o" /><a :href="'tel:' + item.s_telphone" @click.stop="" class="van-card__desc">{{item.s_telphone}}</a>
							</template>
						</van-card>
						<template #right>
							<van-button square text="移除" type="danger" class="van-swipe-cell-button"  @click="moveFavs(item.id)"/>
						</template>
					</van-swipe-cell>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
</template>

<style scoped>
</style>

<script type="text/ecmascript-6">
import { goodUnit, chkURL } from "@/utils/common.js";
import { Sticky, List, Card } from "vant";
export default {
	name: "message",
	components: {
		"van-sticky": Sticky,
		"van-list": List,
		"van-card": Card
	},
	data() {
		return {
			title: "收藏中心",
			items: [],
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url:this.Conf.serverPre,
			ftypes:[{key:1,name:'店铺'},{key:2,name:'商品'}],
			f_type:0,
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,
			viewMessageIndex:-1,
			goodUnitObj:{}
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.getStateConfigs();
		this.goodUnitObj = goodUnit;
		this.loadData();
		this.loadFavTypes();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		loadFavTypes(){
			var url = this.Conf.serverUrl + "User/favTypes" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify({}))
			.then(response => {
				this.ftypes = response.data.data;
			})
			.catch(error => {});
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			if (this.refreshing) {
				this.items = [];
				this.refreshing = false;
			}
			this.page = this.page+1;
			var params = {
				u_id: this.u_id,
				token: this.token,
				types: this.ftypes[this.f_type].key,
				page:this.page,
				lnglat:localStorage.getItem("lnglat")
			};
			var url = this.Conf.serverUrl + "User/myfavs" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.loading = false;
				if (response.data.page == 1) {
					this.pageSize = response.data.pageSize;
					this.total = response.data.total;
					this.items = response.data.infos;
				}else if(response.data.infos){
					this.items = this.items.concat(response.data.infos);
				}
				if(this.page*this.pageSize >= this.total){
					this.finished = true;
				}
			})
			.catch(error => {});
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.items.splice(this.page*this.pageSize);
			this.loadData();
		},
		moveFavs(fid){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定移除此收藏",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					f_id: fid
				};
				var url = this.Conf.serverUrl + "User/movefav" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.$toast(response.data.msg);
					switch (response.data.code) {
						case 200:
							this.onRefresh(true);
							break;
						default:
							return;
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		viewInfo(link){
			if(chkURL(link)){
				if (window.plus) {
						plus.runtime.openURL(link);
				} else {
					window.open(link);
				}
			}else{
				this.$router.push({ path: link });
			}
		}
	},
	watch:{
		f_type(){
			this.onRefresh()
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Favorites.vue